import * as React from 'react';

const Cz16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#C40028",
    d: "M1.38 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2z"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M1.38 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v3h-14z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#29457C",
    d: "M2.027 3.527c-.397.366-.646.89-.646 1.473v6c0 .582.249 1.107.646 1.473L7.511 8z"
  }
));
Cz16.Size = 16;
Cz16.Title = "Cz";

export { Cz16 as default };
